<template>
  <div class="error-page">
    <h1 class="error-type">404</h1>
    <h2 class="error-message">That page does not exist.</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      first_notice_of_loss: 0,
      new_claims_advice: 0,
      hire_monitoring: 0,
      recovery: 0,
      diaries: [],
      paginator_data: {},
      loading: false,
      indicator: false
    };
  },

  computed: {
    hasAccessToFnol() {
      return this.hasModule('first_notice_of_loss');
    },

    hasAccessToNewClaimsAdvice() {
      return this.hasModule('new_claims_advice');
    },

    hasAccessToHireMonitoring() {
      return this.hasModule('hire_monitoring');
    },

    hasAccessToRecovery() {
      return this.hasModule('recovery');
    }
  },

  mounted() {
    this.getFigures();
    this.getDiaries();
  },

  methods: {
    goToFirstNoticeOfLoss() {
      this.route('/first-notice-of-loss');
    },

    goToNewClaimsAdvice() {
      this.route('/new-claims-advice');
    },

    goToHireMonitoring() {
      this.route('/claim-monitoring');
    },

    goToRecovery() {
      this.route('/recovery');
    },

    getFigures() {
      this.findFigures('first_notice_of_loss');
      this.findFigures('new_claims_advice');
      this.findFigures('hire_monitoring');
      this.findFigures('recovery');
    },

    findFigures(category) {
      window.Ajax.get(`/incidents?stage=${category}`)
        .then(response => {
          this[category] = response.data.data.length;
        })
        .catch(error => {});
    },

    getDiaries() {
      window.Ajax.get(`/diary`)
        .then(response => {
          this.diaries = response.data;
        })
        .catch(error => {});
    },

    sendToCreateView() {
      this.indicator = true;
      window.Ajax.post('/incidents', {})
        .then(response => {
          this.indicator = false;
          this.sendToRoute(response.data.identifier);
        })
        .catch(error => {
          this.indicator = false;
          window.toastify.error(
            'Sorry, there was an issue creating the first notice of loss'
          );
        });
    },

    sendToRoute(identifier) {
      this.route(`/first-notice-of-loss/${identifier}`);
    },

    viewIncident(diary) {
      this.route(diary.url);
    },

    formatDate(diary) {
      return window.DateManager.format(diary.date_time);
    }
  }
};
</script>
